/**
 * Single-price cost label for extending an expired invitation (PQ-07).
 * A partner/wallet user pays from their wallet; an individual pays in publish credits.
 */
export function extendCostLabel(isWalletUser: boolean): string {
  // TODO(owner): Hosts pay per invitation per #247; host extension in ₹ is TBD; backend currently checks 2 publish credits or ₹500 from wallet.
  return isWalletUser ? '₹500 from your wallet' : '2 publish credits';
}
